import React from "react"
import PropTypes from "prop-types"
import missingImage from "@/public/images/image-missing.png"
import { generateImageUrl } from "./helper"
import { useQuizContext } from "./QuizContext"

const AnswerTile = ({ data, onClick }) => {
  const { config = {} } = useQuizContext()
  return (
    <div
      className={`answer-tile${data.isSelected ? " selected" : ""}`}
      onClick={onClick}
    >
      <div className="answer-img">
        <img
          src={generateImageUrl(data.img, config, 420, 380)}
          alt={data.title}
          onError={e => (e.target.src = missingImage?.src)}
        />
      </div>
      <div className="answer-content">
        <h3 dangerouslySetInnerHTML={{ __html: data.title }} />
        <p dangerouslySetInnerHTML={{ __html: data.desc }} />
      </div>
    </div>
  )
}

export default AnswerTile

AnswerTile.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string,
    img: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
}
